// Control del rinde al registrar producción.
//
// El costo unitario del producto terminado sale de costo de insumos ÷ rindió,
// y el RPC lo graba en products.cost_price. Un "rindió" mal cargado pisa el
// costo sin aviso: Don Saro, 2026-10-09, 1 tanda de ñoquis que rinde 18 cargada
// como "rindió 1" → costo ×18 ($2.239 → $40.311) y CMV inflado ~$1,1 M.
//
// Reglas:
//  - desvío de rinde > ±50% contra lo esperado por la receta → confirmación aparte.
//  - el costo unitario nuevo queda ≥ ×3 o ≤ ÷3 del costo actual → confirmación
//    aparte (cubre también insumos con costo mal cargado, ej. kg vs unidad).

export const UMBRAL_DESVIO_RINDE_PCT = 50;
export const UMBRAL_SALTO_COSTO = 3;

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

export const evaluarRindeProduccion = ({ rindio, esperado, costoTotal, costoActual } = {}) => {
  const r = num(rindio);
  const e = num(esperado);
  const ct = num(costoTotal);
  const ca = num(costoActual);

  const costoUnitario = r > 0 ? ct / r : 0;
  const desvioPct = e > 0 && r > 0 ? ((r - e) / e) * 100 : 0;
  const factorCosto = ca > 0 && costoUnitario > 0 ? costoUnitario / ca : null;

  const desvioFuerte = e > 0 && r > 0 && Math.abs(desvioPct) > UMBRAL_DESVIO_RINDE_PCT;
  const saltoCostoFuerte = factorCosto != null
    && (factorCosto >= UMBRAL_SALTO_COSTO || factorCosto <= 1 / UMBRAL_SALTO_COSTO);

  return {
    costoUnitario,
    desvioPct,
    factorCosto,
    desvioFuerte,
    saltoCostoFuerte,
    requiereConfirmacion: desvioFuerte || saltoCostoFuerte,
  };
};

/** "×18" / "÷4,2" para mostrar cuánto cambia el costo. */
export const describirFactorCosto = (factor) => {
  if (factor == null || !Number.isFinite(factor) || factor <= 0) return '';
  const fmt = (n) => n.toLocaleString('es-AR', { maximumFractionDigits: 1 });
  return factor >= 1 ? `×${fmt(factor)}` : `÷${fmt(1 / factor)}`;
};
